/**
 * List of all english error messages by error code 
 */
const _messagesEN = {
    900: "An unexpected error occurred",
    901: "This action is not available in offline mode"
};

type ErrorMessageRecord = typeof _messagesEN;

/**
 * List of all french error messages by error code 
 */
const _messagesFR: ErrorMessageRecord = {
    900: "Une erreur inattendue s'est produite",
    901: "Cette action n'est pas disponible hors ligne"
};

/**
 * Action related error messages per language and per code (messages["fr"][900])
 */
export const ERROR_MESSAGES = {
    "en": _messagesEN,
    "fr": _messagesFR
};